import { matchesPartial, SLASH_COMMANDS, type SlashCommand } from "./slash-commands"

export function getFilteredCommands(filter: string): SlashCommand[] {
  const q = filter.trim().toLowerCase()
  if (!q) return SLASH_COMMANDS
  return SLASH_COMMANDS.filter((command) => {
    if (matchesPartial(command.name, q)) return true
    return command.aliases?.some((alias) => matchesPartial(alias, q)) === true
  })
}
